import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
// import moment from 'moment';

import { LandingsPropTypes } from '@mssgme/ui';
import { BACKEND_ENDPOINTS, useCRMData, useFrontAPI, useWebsiteData } from '../../../hooks';
import WayforpayButton from './Buttons/WayforpayButton';

const propTypes = {
    order: LandingsPropTypes.order.isRequired,
    disabled: PropTypes.bool,
};

function extractProduct({ name, price, quantity }) {
    return { name, price: price.amount, count: quantity };
}

export function WayforpayPayment({ order, disabled }) {
    const { finalUrl } = useWebsiteData();
    const { payments } = useCRMData();
    const api = useFrontAPI();
    /*
     * TODO: generate orderReference considering order timeout to avoid duplicated orders in wayforpay personal
     *       cabinet (need more logic in cart and crm for that)
     */
    // const orderPaymentTimeout = 86400; // 1 day
    // const orderCreatedInLocalTime = moment
    //     .utc(order.createdAt)
    //     .local()
    //     .unix();
    // const isOrderPaymentDead = Math.round(Date.now() / 1000) - orderCreatedInLocalTime > orderPaymentTimeout;
    const orderReference = `${order._id}_uniq${Math.floor(Math.random() * 100000)}`;
    const orderDate = useMemo(() => Math.round(Date.now() / 1000), []);
    const products = useMemo(() => order.items.map(extractProduct), [order]);
    const createSignature = useCallback(
        (payload) => api.orders.signatures.createWayforpaySignature({ orderId: order._id, payload }),
        [order._id]
    );
    const returnUrl = BACKEND_ENDPOINTS.getWayforpayCallback(order);

    return (
        <WayforpayButton
            merchantAccount={payments.wayforpay.merchantAccount}
            merchantDomainName={finalUrl}
            orderReference={orderReference}
            orderDate={orderDate}
            amount={order.total.amount}
            currency={order.total.currency}
            products={products}
            createSignature={createSignature}
            returnUrl={returnUrl}
            disabled={disabled}
            // orderPaymentTimeout={orderPaymentTimeout}
        />
    );
}

WayforpayPayment.propTypes = propTypes;
